module.exports = __webpack_public_path__ + "media/bootstrap-icons/peace-9d1a1d0d.svg";